import type { SchoolClass } from "p6m-p6u";
import type { ReactNode } from "react";
import type { ClassActivityCategory } from "../../constants/ClassActivityConstants";
import type { SchoolClassChangeHandler } from "./ClassActivityCardsOverview.types";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";
import { ClassAssignmentTag } from "./classTag/ClassAssignmentTag";

export interface ClassActivityCardExpandedContentProps {
    availableSchoolClasses: SchoolClass[];
    onSchoolClassChange: SchoolClassChangeHandler;
    classActivityCategory: ClassActivityCategory;

    dateLabel?: string;
    topLeftContent?: ReactNode;
    topRightContent?: ReactNode;
    children?: ReactNode;
    selectedSchoolClassId?: string;
    isShared?: boolean;
    isSharedTest?: boolean;
}

export const ClassActivityCardExpandedContent = (props: ClassActivityCardExpandedContentProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();
    const hasTopRow = props.topLeftContent || props.topRightContent;

    return (
        <div className="px-s pb-s">
            <div className="bg-background-light border border-p6-grey-light rounded-b-medium p-m flex flex-col gap-m">
                {hasTopRow && (
                    <div
                        className={`flex flex-wrap items-center gap-s ${getStyleBasedOnBreakpoint(
                            Breakpoint.MD,
                            "flex-row justify-between",
                            "flex-col-reverse items-stretch"
                        )}`}
                    >
                        <div>{props.topLeftContent}</div>
                        <div className={getStyleBasedOnBreakpoint(Breakpoint.MD, "", "self-end")}>
                            {props.topRightContent}
                        </div>
                    </div>
                )}

                {props.children && <div className="flex flex-col gap-s overflow-hidden">{props.children}</div>}

                <div className="flex flex-wrap items-center gap-s">
                    <div className="flex-grow">
                        <ClassAssignmentTag
                            selectedSchoolClassId={props.selectedSchoolClassId}
                            availableSchoolClasses={props.availableSchoolClasses}
                            onSchoolClassChange={props.onSchoolClassChange}
                            classActivityCategory={props.classActivityCategory}
                            isShared={props.isShared}
                            isSharedTest={props.isSharedTest}
                        />
                    </div>
                    {props.dateLabel && (
                        <span className="flex-grow truncate text-l text-p6-grey-mid text-right">{props.dateLabel}</span>
                    )}
                </div>
            </div>
        </div>
    );
};
